import React, { useState } from "react";
import AdminLayout from "../../UI/Layout/AdminLayout";
import Spining from "../../UI/Spining/Spining";
import axios from "axios";
import { userloginDetails } from "../../Utils/AdminAuth";
import Alert from "../../UI/Alert/Alert";
import { NODE_HOST_URL_v1 } from "../../Dashboard/api/Api";

const AdminRcsOnboarding = () => {
    const lStorage = userloginDetails();
    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({
        errorMessage: "",
        isError: false,
        messageType: "",
    });

    const [formData, setFormData] = useState({
        clientId: "",
        clientSecret: "",
        mobile: "",
    });

    const clearAlert = () => {
        setError({
            errorMessage: "",
            isError: false,
            messageType: "",
        });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (loading) return;

        clearAlert();

        const clientId = formData.clientId.trim();
        const clientSecret = formData.clientSecret.trim();
        const mobile = formData.mobile.trim();

        if (!clientId || !clientSecret || !mobile) {
            setError({
                errorMessage: "All fields are required",
                isError: true,
                messageType: "alert alert-danger",
            });
            return;
        }

        // if (!/^\d{10,15}$/.test(mobile)) {
        //     setError({
        //         errorMessage: "Please enter a valid mobile number",
        //         isError: true,
        //         messageType: "alert alert-danger",
        //     });
        //     return;
        // }

        const payload = {
            user_id:userId,
            token: userToken,
            method: "RcsOnboarding",
            clientId,
            clientSecret,
            phoneNumber:mobile,
        };

        try {
            setLoading(true);

            const { data } = await axios.post(
                `${NODE_HOST_URL_v1}/admin/RcsOnboarding`,
                payload
            );

            if (data?.success) {
                setError({
                    errorMessage: data?.message || "RCS Onboarding successful",
                    isError: true,
                    messageType: "alert alert-success",
                });

                setFormData({
                    clientId: "",
                    clientSecret: "",
                    mobile: "",
                });
            } else {
                setError({
                    errorMessage: data?.message || "Something went wrong",
                    isError: true,
                    messageType: "alert alert-danger",
                });
            }
        } catch (error) {
            setError({
                errorMessage:
                    error?.response?.data?.message ||
                    error?.message ||
                    "Something went wrong",
                isError: true,
                messageType: "alert alert-danger",
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <>

            {loading && <Spining />}

            <AdminLayout>
                {error.isError && (
                    <Alert
                        type={error.messageType}
                        clearError={clearAlert}
                    >
                        {error.errorMessage}
                    </Alert>
                )}
                <div className="container-fluid py-4 px-3">
                    <div className="mb-4">
                        <h3 className="fw-semibold text-dark mb-1">RCS Onboarding</h3>
                        <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
                            Enter client credentials and mobile number.
                        </p>
                    </div>

                    <div
                        className="card border-0 shadow-sm"
                        style={{
                            borderRadius: "16px",
                            background: "#ffffff",
                        }}
                    >
                        <div className="card-body p-4">
                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label htmlFor="clientId" className="form-label fw-medium">
                                        Client ID
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="clientId"
                                        name="clientId"
                                        placeholder="Enter client ID"
                                        value={formData.clientId}
                                        onChange={handleChange}
                                        disabled={loading}
                                        autoComplete="off"
                                    />
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="clientSecret" className="form-label fw-medium">
                                        Client Secret
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="clientSecret"
                                        name="clientSecret"
                                        placeholder="Enter client secret"
                                        value={formData.clientSecret}
                                        onChange={handleChange}
                                        disabled={loading}
                                        autoComplete="off"
                                    />
                                </div>

                                <div className="mb-4">
                                    <label htmlFor="mobile" className="form-label fw-medium">
                                        Mobile
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="mobile"
                                        name="mobile"
                                        placeholder="Enter mobile number with country code like +91"
                                        value={formData.mobile}
                                        onChange={handleChange}
                                        disabled={loading}
                                        autoComplete="off"
                                    />
                                </div>

                                <button
                                    type="submit"
                                    className="btn w-100 text-white fw-semibold"
                                    style={{
                                        backgroundColor: "#69be6b",
                                        border: "none",
                                        borderRadius: "10px",
                                        padding: "12px",
                                        opacity: loading ? 0.8 : 1,
                                        cursor: loading ? "not-allowed" : "pointer",
                                    }}
                                    disabled={loading}
                                >
                                    {loading ? "Submitting..." : "Submit"}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </AdminLayout>
        </>
    );
};

export default AdminRcsOnboarding;